import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { TrashIcon, WarningCircle } from "@phosphor-icons/react";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  noteTitle?: string;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  noteTitle,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      classNames={{
        base: "bg-white",
        closeButton: "hover:bg-neutral-primary/5"
      }}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-3 border-b border-neutral-primary/10 pb-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-50">
            <WarningCircle weight="duotone" size={24} className="text-red-500" />
          </div>
          <span className="text-neutral-primary text-lg font-semibold">
            Notitie verwijderen
          </span>
        </ModalHeader>

        <ModalBody className="py-6">
          <p className="text-neutral-primary/70 text-sm leading-relaxed">
            Weet je zeker dat je deze notitie wilt verwijderen?
          </p>
          {noteTitle && (
            <div className="bg-neutral-primary/5 mt-3 rounded-lg p-3">
              <p className="text-neutral-primary text-sm font-medium">
                {noteTitle || "Naamloos"}
              </p>
            </div>
          )}
          <p className="text-neutral-primary/50 mt-3 text-xs">
            De notitie wordt verplaatst naar de prullenbak en kan later worden hersteld.
          </p>
        </ModalBody>

        <ModalFooter className="border-t border-neutral-primary/10 pt-3">
          <Button
            variant="light"
            onPress={onClose}
            className="text-neutral-primary/70"
          >
            Annuleren
          </Button>
          <Button
            color="danger"
            onPress={() => {
              onConfirm();
              onClose();
            }}
            startContent={<TrashIcon weight="bold" size={16} />}
            className="bg-red-500 text-white"
          >
            Verwijderen
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
